import React, { useState, useContext, useEffect, useCallback } from "react";
import api from "../context/api";
import { GameContext } from "../context/GameContext";
import { AuthContext } from "../context/AuthContext";

import "../styles/UserHistory.css";

import "../styles/BetHistory.css";

const arraysEqual = (a, b) => {
  if (a === b) return true;
  if (a == null || b == null) return false;
  if (a.length !== b.length) return false;
  for (let i = 0; i < a.length; ++i) {
    if (a[i] !== b[i]) return false;
  }
  return true;
};

 export const BetHistory = () => {
  const { token } = useContext(AuthContext);
  const [userData, setUserData] = useState(null);
  const [visibleItemCount, setVisibleItemCount] = useState(3);
  const [refreshing, setRefreshing] = useState(false);
  const [visibilityUpdatingId, setVisibilityUpdatingId] = useState("");

  useEffect(() => {
    fetchUserData();
    // eslint-disable-next-line
  }, []);

  const fetchUserData = async () => {
    try {
      setRefreshing(true);
      const headers = token ? { Authorization: `Bearer ${token}` } : {};
      const response = await api.get(`/history/:id`, { headers });
      const sanitizedHistoryData = Array.isArray(response.data?.historyData)
        ? response.data.historyData.filter((entry) => !entry.isDeleted)
        : [];
      setUserData({ ...response.data, historyData: sanitizedHistoryData });
    } catch (error) {
      // Optionally handle error
    } finally {
      setRefreshing(false);
    }
  };

  const handleViewMore = () => {
    setVisibleItemCount((prevCount) => prevCount + 5);
  };

  const handleDelete = async (itemId) => {
    if (window.confirm("Are you sure you want to delete this game?")) {
      try {
        const headers = token ? { Authorization: `Bearer ${token}` } : {};
        const response = await api.delete(`/delete/${itemId}`, { headers });
        if (response.status === 200) {
          fetchUserData();
        } else {
          alert("Failed to delete game: " + response.status);
        }
      } catch (error) {
        alert("Error: " + error.message);
      }
    }
  };

  const handleToggleShortIdVisibility = async (item, explicitShowInShortId) => {
    const ticketId = String(item?.id || "").trim();
    if (!ticketId) return;

    try {
      setVisibilityUpdatingId(ticketId);
      const nextShowInShortId =
        typeof explicitShowInShortId === "boolean"
          ? explicitShowInShortId
          : item?.showInShortId === false;
      const headers = token ? { Authorization: `Bearer ${token}` } : {};

      await api.patch(
        `/history/visibility/${encodeURIComponent(ticketId)}`,
        { showInShortId: nextShowInShortId },
        { headers }
      );

      setUserData((prev) => {
        if (!prev || !Array.isArray(prev.historyData)) return prev;
        return {
          ...prev,
          historyData: prev.historyData.map((entry) =>
            entry.id === ticketId
              ? { ...entry, showInShortId: nextShowInShortId }
              : entry
          ),
        };
      });
    } catch (error) {
      alert(error?.response?.data?.error || "Failed to update sharing visibility.");
    } finally {
      setVisibilityUpdatingId("");
    }
  };

  const formatAmount = (amount) => {
    return parseFloat(amount).toLocaleString("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  const getLimitLabel = useCallback((limit) => {
    const numericLimit = limit.map(Number);
    if (arraysEqual(numericLimit, [1, 2])) return "DIRECT 2";
    if (arraysEqual(numericLimit, [1, 3])) return "DIRECT 3";
    if (arraysEqual(numericLimit, [3, 24])) return "PERM 2";
    if (arraysEqual(numericLimit, [4, 17])) return "PERM 3";
    if (arraysEqual(numericLimit, [5, 13])) return "PERM 4";
    if (arraysEqual(numericLimit, [6, 12])) return "PERM 5";
    if (arraysEqual(numericLimit, [1, 1])) return "Banker Against All";
    if (arraysEqual(numericLimit, [1, 24])) return "Banker Against";
    return "";
  }, []);

  const copyToClipboard = async (id) => {
    try {
      await navigator.clipboard.writeText(id);
      alert("Copied to clipboard!");
    } catch {
      alert("Failed to copy!");
    }
  };

  return (
    <div className="user-details-container">
      
      <div className="history-view">
        <div className="scroll-view">
          {userData &&
          userData.historyData &&
          Array.isArray(userData.historyData) ? (
            <div className="number-view">
              {userData.historyData
                .slice(0, visibleItemCount)
                .map((item, subIndex) => {
                  const limitLabel = getLimitLabel(item.limit);
                  return (
                    <div className="card3" key={subIndex}> 
                      <div className="card-content">
                        {item.outcome === "Pending" && (
                          <label
                            className="visibility-checkbox-wrap"
                            title={item.showInShortId === false ? "Click to show in ShortId" : "Click to hide from ShortId"}
                          >
                            <input
                              type="checkbox"
                              className="hide-checkbox"
                              checked={item.showInShortId !== false}
                              disabled={visibilityUpdatingId === item.id}
                              onChange={(e) =>
                                handleToggleShortIdVisibility(item, e.target.checked)
                              }
                            />
                            <span
                              className={`hide-status ${
                                visibilityUpdatingId === item.id
                                  ? "visibility-updating"
                                  : item.showInShortId === false
                                  ? "hide-status-off"
                                  : "hide-status-on"
                              }`}
                            >
                              {visibilityUpdatingId === item.id
                                ? "Updating..."
                                : item.showInShortId === false
                                ? "Hidden"
                                : "Visible"}
                            </span>
                          </label>
                        )}
                        <button
                          className="delete-btn"
                          onClick={() => handleDelete(item.id)}
                          title="Delete"
                        >
                          🗑️
                        </button>
                        <div className="label-text">Draw Date: {item.NextGameDate}</div>
                        <div className="label-text">Game: {item.selectedDay}</div>
                        <div className="label-text">Game Played: {limitLabel}</div>
                        <div className="label-text">Price: {formatAmount(item.price)}</div>
                        <div className="label-text" style={{ color: item.color || "yellow" }}>
                          Status: {item.outcome || "Pending"}
                        </div>
                       
                        <div className="label-text">Played Numbers</div>
                        <div className="row-view">
                          {item.selectedNumbers &&
                            item.selectedNumbers.map((number, idx) => {
                              const isCommonNumber =
                                item.commonNumbers &&
                                item.commonNumbers.includes(String(number));
                              const backgroundColor = isCommonNumber ? "yellow" : "#fff";
                              return (
                                <span
                                  className="number-button"
                                  key={idx}
                                  style={{ backgroundColor }}
                                >
                                  {number}
                                </span>
                              );
                            })}
                        </div>

                        <div className="label-text">Draw Numbers</div>
                        <div className="row-view">
                          {Array.isArray(item.nlaNumbers) && item.nlaNumbers.length > 0 ? (
                            item.nlaNumbers.map((number, idx) => {
                              const selectedNumbersAsString = (item.selectedNumbers || []).map(String);
                              const isMatchedWithTicket = selectedNumbersAsString.includes(String(number));
                              const backgroundColor = isMatchedWithTicket ? "yellow" : "#08f79c";

                              return (
                                <span
                                  className="number-button"
                                  key={`nla-${idx}-${number}`}
                                  style={{ backgroundColor }}
                                >
                                  {number}
                                </span>
                              );
                            })
                          ) : (
                            <span className="label-text" style={{ color: "#9ca3af" }}>
                               Draw not posted yet
                            </span>
                          )}
                        </div>

                        {/* Uncomment and style if you want to show againstNumbers
                        <div className="label-text">againstNumbers</div>
                        <div className="row-view">
                          {item.againstNumbers &&
                            item.againstNumbers.map((number, idx) => {
                              const isCommonNumber =
                                item.commonNumbers &&
                                item.commonNumbers.includes(String(number));
                              const backgroundColor = isCommonNumber ? "yellow" : "#fff";
                              return (
                                <span
                                  className="number-button1"
                                  key={idx}
                                  style={{ backgroundColor }}
                                >
                                  {number}
                                </span>
                              );
                            })}
                        </div>
                        */}
                        {item.outcome === "Lost" ? (
                          <div className="label-text" style={{ color: item.color }}>
                            Missed Amount: Gh₵
                            {formatAmount(item.maximumWin || item.minimumWin)}
                          </div>
                        ) : item.outcome === "Pending" ? (
                          <>
                            <div className="label-text" style={{ color: "yellow" }}>
                              Potential Win: Gh₵
                              {formatAmount(item.maximumWin || item.minimumWin)}
                            </div>
                            <button
                              className="copy-btn"
                              onClick={() => copyToClipboard(item.id)}
                            >
                              Share ID:{" "}
                              <span className="share-text">
                                {item.id} <span className="copy-button">(Copy)</span>
                              </span>
                            </button>
                          </>
                        ) : (
                          <>
                            <div className="label-text" style={{ color: item.color }}>
                              Amount Won: Gh₵{formatAmount(item.winPrice)}
                            </div>
                            <div className="label-text" style={{ color: item.color }}>
                              Pay Status: {item.paid}
                            </div>
                          </>
                        )}
                      </div>
                    </div>
                  );
                })}
              {userData.historyData.length > visibleItemCount && (
                <div className="view-more-container">
                  <button className="view-more" onClick={handleViewMore}>
                    Load More
                  </button>
                </div>
              )}
            </div>
          ) : (
            <div style={{ textAlign: "center", margin: 15 }}>
              pull to load data...
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

